import { Component, OnInit } from '@angular/core';
import { CrudService } from '../crud.service';
@Component({
  selector: 'app-womens-grievance-redressal-committee',
  templateUrl: './womens-grievance-redressal-committee.component.html',
  styleUrls: ['./womens-grievance-redressal-committee.component.scss']
})
export class WomensGrievanceRedressalCommitteeComponent implements OnInit {

  constructor(private crudService: CrudService) { }
  baseUrl = this.crudService.baseUrl;

  ngOnInit(): void {
  }

}
